import { useMutation } from '@hooks/reactQuery';

import { getTree } from '@api/configurationComparison';

import { TTreeCCModuleDTO } from '@interfaces/cmModule/dto/configurationComparisonDTO';
import { ITreeInitial } from '@interfaces/components/tree';

import { CC_TREE } from '@constants/queryKeys';

export const useMutateTree = (onSettledCallback: () => void) => {
	const {
		data: tree,
		mutate: generateTree,
		isLoading: isLoadingGenerateTree,
	} = useMutation<TTreeCCModuleDTO, {
		moTree: ITreeInitial;
		treeIds: string;
	}>({
		mutationKey: [CC_TREE],
		mutationFn: getTree,
		onSuccess: onSettledCallback,
	});

	return { generateTree, tree, isLoadingGenerateTree };
};
